import { render } from "./Servicos.vue?vue&type=template&id=4ea29c28&scoped=true&async=true"
import script from "./Servicos.vue?vue&type=script&async=true&lang=js"
export * from "./Servicos.vue?vue&type=script&async=true&lang=js"

import "./Servicos.vue?vue&type=style&index=0&id=4ea29c28&async=true&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea29c28"]])

export default __exports__